<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-100">
        <p class="md-title">Notificações {{ localName && '- ' + localName }}</p>
      </div>
    </div>
    <hr />
    <Loading :loading="!notificacoes" />
    <div v-if="notificacoes">
      <div v-if="notificacoes.length" style="min-height: 60vh">
        <md-table>
          <md-table-row>
            <md-table-head>Título</md-table-head>
            <md-table-head>Mensagem</md-table-head>
            <md-table-head>Horário</md-table-head>
            <md-table-head class="col-minimal"></md-table-head>
          </md-table-row>
          <md-table-row
            v-for="notificacao in notificacoes"
            :key="notificacao.id"
          >
            <md-table-cell>{{ notificacao.titulo }}</md-table-cell>
            <md-table-cell>{{ notificacao.mensagem }}</md-table-cell>
            <md-table-cell>{{
              formatDate(notificacao.horarioEnvio)
            }}</md-table-cell>
            <md-table-cell class="col-minimal">
              <div class="md-layout md-gutter" style="flex-wrap: nowrap">
                <md-icon
                  class="md-layout-item md-primary"
                  :style="{
                    ['opacity']: shouldShowScheduleIcon(
                      notificacao.horarioEnvio
                    ),
                  }"
                >
                  schedule
                  <md-tooltip
                    v-if="shouldShowScheduleIcon(notificacao.horarioEnvio)"
                    md-direction="left"
                  >
                    Notificação enviada há menos de 1 hora
                  </md-tooltip>
                </md-icon>
                <md-icon
                  class="md-primary"
                  :style="{
                    ['color']: getNotificationIconColor(
                      notificacao.nivelNotificacao
                    ),
                    ['border-radius']: '2px',
                    ['min-height']: '2vh',
                    ['min-width']: '2vh',
                  }"
                >
                  {{ getNotificationIconName(notificacao.nivelNotificacao) }}
                  <md-tooltip md-direction="left">
                    {{
                      getNotificationIconTooltip(notificacao.nivelNotificacao)
                    }}
                  </md-tooltip>
                </md-icon>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div v-else class="align-center mt-5">
        <md-empty-state
          md-rounded
          md-icon="info"
          md-label="Nenhuma notificação encontrada"
          md-description="Nenhuma notificação foi encontrada com os filtros aplicados"
        />
      </div>
      <flow-pagination
        class="mt-3"
        :current-page="currentPage"
        :page-count="pageCount"
        :page-size="pageSize"
        :total-count="totalCount"
        :total-pages="totalPages"
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import FlowPagination from '@/components/FlowPagination.vue'
import Loading from '@/components/Loading.vue'
import store from '@/store'
import http from '@/utils/http'
import {
  formatDate,
  getNotificationIconColor,
  getNotificationIconName,
  getNotificationIconTooltip,
} from '@/utils/transform'

export default {
  name: 'AuditoriaNotificacoes',
  components: {
    FlowPagination,
    Loading,
  },
  data() {
    return this.getInitialState()
  },
  computed: {
    localName: function () {
      if (this.localId) {
        return store.state.locais[this.localId]?.nome
      }

      return null
    },
  },
  watch: {
    $route() {
      this.updateStateFromQuery()
      this.searchNotificacoes(this.currentPage)
    },
  },
  beforeMount() {
    this.updateStateFromQuery()
    this.searchNotificacoes(this.currentPage)
  },
  methods: {
    formatDate,
    getNotificationIconColor,
    getNotificationIconName,
    getNotificationIconTooltip,
    getInitialState() {
      return {
        localId: null,
        notificacoes: null,
        currentPage: 1,
        pageCount: 0,
        totalPages: 1,
        totalCount: 0,
        pageSize: 20,
      }
    },
    handlePageChange(page) {
      this.updateRoute(page)
    },
    updateStateFromQuery() {
      this.localId = this.$route.params.localId
      const initialState = this.getInitialState()
      this.currentPage =
        parseInt(this.$route.query.page) || initialState.currentPage
      this.pageSize =
        parseInt(this.$route.query.pageSize) || initialState.pageSize
    },
    updateRoute(page) {
      const queryParams = {
        page: page,
        pageSize: this.pageSize,
      }

      const filteredQuery = Object.fromEntries(
        Object.entries(queryParams).filter(([, value]) => value !== null)
      )

      this.$router.push({ query: filteredQuery })
    },
    async searchNotificacoes(page) {
      this.notificacoes = null
      const response = (
        await http.get(`local/${this.localId}/notificacoes/historico`, {
          page: page,
          pageSize: this.pageSize,
        })
      ).historico
      this.currentPage = page
      this.pageCount = response.results.length
      this.totalPages = response.pageCount
      this.totalCount = response.rowCount
      this.notificacoes = response.results
    },
    shouldShowScheduleIcon(notificacaoHorarioEnvio) {
      const currentDate = new Date()
      const notificationDate = new Date(notificacaoHorarioEnvio)
      const millisecondsDiff = currentDate - notificationDate
      const hoursDiff = Math.floor(millisecondsDiff / 1000 / 60 / 60)
      return hoursDiff ? 0 : 1
    },
  },
}
</script>

<style>
.col-minimal {
  width: 1%;
  white-space: nowrap;
}
</style>
